import React        from 'react';
import d3           from 'd3';
import PieChartPie from '../PieChartPie/PieChartPie.jsx';
import SizeGiver from '../../../containers/SizeGiver/SizeGiver.jsx';
import SVGChart from '../SVGChart/SVGChart.jsx';
import HtmlLegend from '../HtmlLegend/HtmlLegend.jsx';

//[props.paddingLeft, props.width - props.paddingRight]);    



export default class PieChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {selectedIdx: null, hoveredIdx: null}
        this.sliceClick = this.sliceClick.bind(this);
        this.sliceMouseEnter = this.sliceMouseEnter.bind(this);
        this.sliceMouseLeave = this.sliceMouseLeave.bind(this);
    }
    sliceClick(i) {
        if(this.state.selectedIdx==i) {
            this.setState({selectedIdx:null});
        } else {
            this.setState({selectedIdx:i});
        }      
    }
    sliceMouseEnter(i) {
        this.setState({hoveredIdx:i});    
    }
    sliceMouseLeave(i) {
        this.setState({hoveredIdx:null});    
    }
    render() {
        const d3Props = Object.assign({},this.props);
        return <div style={{width:"100%"}} className="piechart">
            <SizeGiver>
                <SVGChart {...d3Props} trackMouse={false}>
                    <PieChartPie 
                    selected={this.state.selectedIdx}
                    hovered={this.state.hoveredIdx}
                    onSliceClick={this.sliceClick}
                    onSliceMouseOver={this.sliceMouseEnter}
                    onSliceMouseEnter={this.sliceMouseEnter}
                    onSliceMouseLeave={this.sliceMouseLeave}
                    innerContent={this.props.children}
                    />
                </SVGChart>
            </SizeGiver>
            <HtmlLegend 
                data={d3Props.data}
                selected={this.state.selectedIdx}
                hovered={this.state.hoveredIdx}
                symboltype="circle"
                onItemClick={this.sliceClick}
                onItemMouseOver={this.sliceMouseEnter}
                onItemMouseEnter={this.sliceMouseEnter}
                onItemMouseLeave={this.sliceMouseLeave}/>
        </div>
        
    }
    
}

//<Legend {...d3Props} legendtype="line"/>


// WEBPACK FOOTER //
// ./src/js/components/charting/PieChart/PieChart.jsx